/**
 * Create the store with dynamic reducers
 */

import { configureStore } from '@reduxjs/toolkit';

import { applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createReducer from './reducers';
import globalSaga from '@redux/global/saga';
import userSaga from '@redux/user/saga';
import chatSaga from 'common/components/message/controller/saga';
import ssoProductSaga from 'pages/sso-product/controllers/saga';
import messagesSaga from 'pages/messages/controllers/saga';

export default function configureAppStore(initialState = {}) {
  const reduxSagaMonitorOptions = {};

  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  // 2. routerMiddleware: Syncs the location/URL path to the state
  const middlewares = [sagaMiddleware];

  const enhancers = [applyMiddleware(...middlewares)];

  const store = configureStore({
    reducer: createReducer(),
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({
        thunk: false,
        serializableCheck: false,
      }),
    ],
    initialState,
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(enhancers),
  });

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry
  // run global, branding saga
  store.runSaga(globalSaga);
  store.runSaga(chatSaga);
  store.runSaga(userSaga);
  store.runSaga(ssoProductSaga);
  store.runSaga(messagesSaga);

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return store;
}
